export default "__VITE_ASSET__ByCUiu6B__"